<div class="comparison-grid expanded-mode"
     data-test="period-comparison-grid"
     [formGroup]="form()"
>
  <!-- External Period Name -->
  <div data-test="external-period-placeholder">
  </div>
  <!-- Local Period Name -->
  <div class="override-cell"
       data-test="override-period-cell"
  >
    <albert-select controlName="uuid"
                   inputId="ovr_name"
                   label="Period"
                   [attr.data-test]="'override-period-select'"
                   [editable]="false"
                   [options]="periodOptions() ?? []"
    />
  </div>
</div>
